export const profilePictureName = 'profile-picture';
